import React, { useEffect, useState } from "react";
import ManagementSidebar from "./ManagementSidebar";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Tabs,
  Tab,
  Box,
  Tooltip,
  useTheme,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Badge,
  Pagination,
  List,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { showToast, WEBSERVICE } from "../../CoreDataService";
import { useSelector } from "react-redux";
import ModalContent from "../../Common/Modal";

// ── Design tokens ────────────────────────────────────────────────────────────
const pageWrapper = {
  px: { xs: 2, md: 4 },
  py: { xs: 2, md: 3 },
  backgroundColor: "var(--body-color)",
  color: "var(--text-color)",
  minHeight: "calc(100vh - 64px)",
};

const contentHero = {
  borderRadius: "18px",
  px: { xs: 3, md: 4 },
  py: { xs: 2.5, md: 3 },
  mb: 3,
  position: "relative",
  overflow: "hidden",
  boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
};

const heroContent = { display: "flex", alignItems: "center", gap: 2 };

const heroIconBadge = {
  width: 52,
  height: 52,
  borderRadius: "14px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(255,255,255,0.18)",
  border: "1px solid rgba(255,255,255,0.25)",
  backdropFilter: "blur(6px)",
  flexShrink: 0,
};

const heroTitle = {
  fontSize: { xs: "1.2rem", md: "1.5rem" },
  fontWeight: 700,
  color: "#fff",
  lineHeight: 1.15,
};

const heroSubtitle = {
  fontSize: "0.85rem",
  color: "rgba(255,255,255,0.88)",
  mt: 0.4,
};

const filterCard = {
  backgroundColor: "var(--body-color-less2)",
  borderRadius: "12px",
  border: "1px solid rgba(125,125,125,0.12)",
  p: { xs: 2, md: 2.5 },
  mb: 3,
};

const mainCard = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 10px 25px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

const tabsWrap = {
  borderBottom: "1px solid rgba(125,125,125,0.15)",
  px: { xs: 1, md: 2 },
  backgroundColor: "var(--body-color-less2)",
};

const tabItem = {
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.9rem",
  color: "var(--text-color)",
  opacity: 0.65,
  "&.Mui-selected": { color: "var(--text-color)", opacity: 1 },
};

const modernTableContainer = {
  borderRadius: "0",
  border: "none",
  boxShadow: "none",
  overflowX: "auto",
  backgroundColor: "var(--body-color-less)",
};

const modernTableHeadRow = { backgroundColor: "var(--body-color-less2)" };

const modernTableHeadCell = {
  fontWeight: 700,
  fontSize: "0.72rem",
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  color: "var(--text-color)",
  opacity: 0.75,
  borderBottom: "1px solid rgba(125,125,125,0.15)",
  py: 1.75,
  whiteSpace: "nowrap",
};

const modernTableBodyRow = {
  transition: "background-color 0.15s ease",
  "&:hover": { backgroundColor: "var(--body-color-less2)" },
  "&:last-child td": { borderBottom: 0 },
};

const modernTableBodyCell = {
  fontSize: "0.85rem",
  py: 1.65,
  borderBottom: "1px solid rgba(125,125,125,0.12)",
  color: "var(--text-color)",
  whiteSpace: "nowrap",
};

const modernFieldStyle = {
  "& .MuiInputBase-root": {
    borderRadius: "10px",
    backgroundColor: "var(--body-color)",
    color: "var(--text-color)",
  },
  "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(125,125,125,0.25)" },
  "& .MuiInputLabel-root": { color: "var(--text-color)", opacity: 0.7 },
  "& .MuiSelect-icon": { color: "var(--text-color)" },
};
// ─────────────────────────────────────────────────────────────────────────────


const TransuctionHistory = () => {
  const themeColor = localStorage.getItem("theme");
  const { btncolor, brokerMarkets } = useSelector((state) => state);
  const navigate = useNavigate();
  const location = useLocation();
  const openIndex = location.state?.openIndex;
  const timeSpan = "all";
  const CURRENCYICON = "$ ";
  const [selectedSubAccount, setSelectedSubAccount] = useState("");
  const [subAccountsData, setSubAccountsData] = useState([]);
  const [selectedUuid, setSelectedUuid] = useState("");
  const [selectedEmail, setSelectedEmail] = useState("");

  const [historyDetailsMod, setHistoryDetailsMod] = useState([]);
  const [historyDetails, setHistoryDetails] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [, setPgn] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [selectedCurrencyText, setSelectedCurrencyText] = useState("");

  const [futuresTxnList, setFuturesTxnList] = useState([]);
  const [futuresTxnListHeader, setFuturesTxnListHeader] = useState([]);
  const [ftotalCount, setFtotalCount] = useState(0);
  const [, setFpgn] = useState([]);

  const [optionTxnList, setOptionTxnList] = useState([]);
  const [optionTxnListHeader, setOptionTxnListHeader] = useState([]);
  const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);
  const [invoiceData, setInvoiceData] = useState({});

  const theme = useTheme();
  const [value, setValue] = useState("spot");
  const [pageNo, setPageNo] = useState(1);
  const [totalItem, setTotalItem] = useState(0);

  const valueClass =
    themeColor === "dark"
      ? "font-weight-bold font-sm text-white"
      : "font-weight-bold font-sm text-blue";

  const itemsPerPage = 10;
  const totalPages = Math.ceil(totalItem / itemsPerPage);

  const handleClose = () => setInvoiceModalOpen(false);

  const handlePageChange = (_event, pgno) => {
    setPageNo(pgno);
    if (value === "spot") {
      getSpotTranscationHistory(pgno);
    }
    if (value === "futures") {
      renderFuturesTxnHistory(pgno);
    }
    if (value === "options") {
      renderOptionsTxnHistory(pgno);
    }
  };

  const handleTabChange = () => {
    setPageNo(1);
    setTotalItem(0);
  };

  const handleChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedSubAccount(selectedValue);
    setSelectedUuid(selectedValue?.uuid);
    setSelectedEmail(selectedValue?.email);
    setValue("spot");
  };

  useEffect(() => {
    getListOfAllSubAccounts();
  }, []);

  useEffect(() => {
    if (value === "futures" && brokerMarkets?.isFutures === 0) {
      setValue("spot");
    } else if (value === "options" && brokerMarkets?.isOptions === 0) {
      setValue("spot");
    }
  }, [brokerMarkets, value]);

  const getListOfAllSubAccounts = async () => {
    const payload = {
      parentId: localStorage.getItem("uuid"),
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}assetManagement/getAllSubAccounts`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const res = response.data;

      if (res.statusCode !== 0) {
        showToast("error", res.message);
      } else {
        setSubAccountsData(res["sub accounts"]);
      }
    } catch (error) {
      showToast("error", "Something went wrong!");
    }
  };

  useEffect(() => {
    if (selectedUuid) {
      getSpotTranscationHistory(1);
    }
  }, [selectedUuid]);

  const getSpotTranscationHistory = (pageNo) => {
    if (selectedUuid) {
      let payload = {};
      payload["parentId"] = localStorage.getItem("uuid");
      payload["uuid"] = selectedUuid;
      payload["pageNo"] = pageNo;
      payload["noOfItemsPerPage"] = 20;
      payload["timeSpan"] = timeSpan;
      payload["transactionType"] = "all";

      let jsonString = JSON.stringify(payload);

      axios
        .post(
          `${WEBSERVICE}assetManagement/subAccountSpotHistory`,
          jsonString,
          {
            headers: {
              "Content-Type": "application/json",
              authorization: "BEARER " + localStorage.getItem("access_token"),
            },
          }
        )
        .then((response) => {
          const res = response.data;
          if (res.error.error_data !== 0) {
            showToast("error", res.error.error_msg);
          } else {
            const history = res.userTransactionsResult;
            setHistoryDetails(history);
            setTotalCount(res.totalCount);

            let processedData = [];
            const currency = localStorage
              .getItem("selected_currency")
              .toUpperCase();
            setSelectedCurrency(currency);
            setSelectedCurrencyText(currency);

            if (history != null) {
              for (let i = 0; i < history.length; i++) {
                let item = history[i];
                let action = item.action;
                let copyTradeFlag = item.copyTradeFlag;
                let amount = "";
                let hrefForTxn = "";
                let status = "";
                let statusClass = "";
                let transactionId = item.orderid || item.transactionId;

                const currencyUpper = (item.currency || "").toUpperCase();
                const baseCurrency = item.baseCurrency || "";
                const debitAmount = item.debitAmount;
                const creditAmount = item.creditAmount;

                if (
                  [
                    "Buy",
                    "Buyoffer",
                    "Sell",
                    "Buydel",
                    "Margin",
                    "Funding",
                    "Buymodify",
                    "Sellmodify",
                    "Selloffer",
                  ].includes(action)
                ) {
                  amount = `<span class="text-white">${item.tradeAssetAmount}</span>`;
                }

                if (action === "Selldel") {
                  amount = `<span class="text-white">${currencyUpper} ${creditAmount === 0
                      ? debitAmount + " Dr."
                      : creditAmount + " Cr."
                    }</span>`;
                }

                if (["Rollback", "rollback", "RollBack"].includes(action)) {
                  if (
                    baseCurrency !== "usd" &&
                    item.currency !== "usd" &&
                    creditAmount !== 0
                  ) {
                    if (
                      !baseCurrency ||
                      baseCurrency === "-" ||
                      baseCurrency == null
                    ) {
                      amount = `<span class="text-white">${currencyUpper} ${creditAmount} Cr.</span>`;
                    }
                  }
                }

                if (["Send", "Sent"].includes(action) && debitAmount !== 0) {
                  amount = `<span class="text-white">${item.tradeAssetAmount}</span>`;
                  if (
                    item.currencyTxnid &&
                    item.currencyTxnid !== "null" &&
                    item.currencyTxnid.length >= 10
                  ) {
                    hrefForTxn = `<a target="_blank" href="https://blockexplorer.com/tx/${item.currencyTxnid}">(Check Transaction Block)</a>`;
                  }
                }

                if (
                  ["Receive", "Received"].includes(action) &&
                  creditAmount !== 0
                ) {
                  amount = `<span class="text-white">${item.tradeAssetAmount}</span>`;
                  if (
                    item.currencyTxnid &&
                    item.currencyTxnid !== "null" &&
                    item.currencyTxnid.length >= 10
                  ) {
                    hrefForTxn = `<a target="_blank" href="https://blockexplorer.com/tx/${item.currencyTxnid}">(Check Transaction Block)</a>`;
                  }
                }

                if (action === "Load") {
                  if (currencyUpper === "USD") {
                    amount = `<span class="text-white">${CURRENCYICON} ${creditAmount} Cr.</span>`;
                  } else if (currencyUpper === "AED") {
                    amount = `<span class="text-white">د.إ ${creditAmount} Cr.</span>`;
                  } else {
                    amount = `<span class="text-white">₹ ${creditAmount} Cr.</span>`;
                  }
                }

                if (action === "Withdraw") {
                  if (currencyUpper === "USD") {
                    amount = `<span class="text-white">${CURRENCYICON} ${debitAmount} Dr.</span>`;
                  } else if (currencyUpper === "AED") {
                    amount = `<span class="text-white">د.إ ${debitAmount} Dr.</span>`;
                  } else {
                    amount = `<span class="text-white">₹ ${debitAmount} Dr.</span>`;
                  }
                }

                if (action === "Decline") {
                  amount = `<span class="text-white">${currencyUpper} ${creditAmount} Cr.</span>`;
                }

                if (action === "Send Decline") {
                  amount = `<span class="text-white">${currencyUpper} ${debitAmount} Dr.</span>`;
                }

                if (item.status === 0) {
                  status = "Pending";
                  statusClass = "text-orange";
                } else if (item.status === 1) {
                  status = "Confirmed";
                  statusClass = "text-green";
                } else {
                  status = action;
                  statusClass = "text-red";
                }

                if (action === "Buyoffer") action = "Buy Offer";
                if (action === "Selloffer") action = "Sell Offer";

                processedData.push({
                  timestamp: item.transactionTimestamp,
                  transactionId: transactionId,
                  tradeAssetAmount: item.tradeAssetAmount,
                  action: action,
                  status: status,
                  statusClass: statusClass,
                  copyTradeFlag: copyTradeFlag,
                  description: item.description,
                });
              }

              setHistoryDetailsMod(processedData);
              setTotalItem(processedData?.length);
              setPgn(
                Array.from(
                  { length: Math.ceil(res.totalCount / 20) },
                  (_, i) => i + 1
                )
              );
            } else {
              setHistoryDetailsMod([{ noData: true }]);
              setTotalItem(0);
            }
          }
        })
        .catch((error) => {
          const err = error.response?.data?.error;
          if (err?.error === "invalid_token") {
            showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
            //logout
          } else {
            // showToast('error',"SESSION TIMED OUT. LOGIN AGAIN");
          }
        });
    } else {
      setHistoryDetailsMod([]);
    }
  };

  const logout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  const renderFuturesTxnHistory = (fpage) => {
    const payload = {
      parentId: localStorage.getItem("uuid"),
      uuid: selectedUuid,
      no_of_items_per_page: 20,
      page_no: fpage,
    };

    axios
      .post(`${WEBSERVICE}assetManagement/subAccountFuturesHistory`, payload, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        const result = response.data;
        if (result.statuscode !== "0") {
          setFuturesTxnList(result.transactionHistory);
          setTotalItem(result.transactionHistory?.length);
          setFuturesTxnListHeader(result.header);
          setFtotalCount(result.totalRows);

          const totalPages = Math.ceil(result.totalRows / 20);
          const pages = [];
          for (let i = 1; i <= totalPages; i++) {
            pages.push(i);
          }
          setFpgn(pages);
        } else {
          showToast("error", result.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching futures transaction history:", error);
        showToast("error", "Something went wrong while fetching data.");
      });
  };

  const renderOptionsTxnHistory = (page) => {
    const payload = {
      parentId: localStorage.getItem("uuid"),
      no_of_items_per_page: 20,
      page_no: page,
      uuid: selectedUuid,
    };

    axios
      .post(
        `${WEBSERVICE}assetManagement/subAccountOptionsHistory`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      )
      .then((response) => {
        const result = response.data;
        if (result.statuscode !== 0) {
          setOptionTxnList(result.transactionHistory);
          setTotalItem(result.transactionHistory?.length);
          setOptionTxnListHeader(result.header);
        } else {
          showToast("error", result.message);
        }
      })
      .catch((error) => {
        if (error?.response?.data?.error === "invalid_token") {
          showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
          //logout
        } else {
          // showToast('SESSION TIMED OUT. LOGIN AGAIN', 'danger');
        }
      });
  };

  const getInvoiceDataById = async (txnId) => {
    let payload = {};

    payload["transactionId"] = txnId;

    let jsonString = JSON.stringify(payload);
    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/tradingInvoice`,
        jsonString,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );
      const res = response?.data;
      if (res.error.error_data !== 0) {
        showToast("error", res.error.error_msg);
      } else {
        setInvoiceData(res?.tradeInvoice);
        setInvoiceModalOpen(true);
      }
    } catch (error) {
      const err = error.response?.data?.error;
      if (err?.error === "invalid_token") {
        showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
      } else {
        // showToast('error',"SESSION TIMED OUT. LOGIN AGAIN");
      }
    }
  };

  const clickToOpenModal = (txnId) => {
    getInvoiceDataById(txnId);
  };

  const formatDate = (date) => new Date(date).toLocaleString();

  return (
    <Grid container spacing={1} sx={{ mx: 1, overflowX: "hidden" }}>
      <Grid size={{ xs: 12, md: 2 }}>
        <ManagementSidebar index={openIndex} />
      </Grid>
      <Grid size={{ xs: 12, md: 10 }}>
        <Box sx={pageWrapper}>
          {/* Hero Banner */}
          <Box
            sx={{
              ...contentHero,
              background: `linear-gradient(135deg, ${alpha(btncolor || "#1976d2", 0.95)} 0%, ${alpha(btncolor || "#1976d2", 0.75)} 100%)`,
            }}
          >
            <Box sx={heroContent}>
              <Box sx={heroIconBadge}>
                <ReceiptLongIcon sx={{ color: "#fff", fontSize: 26 }} />
              </Box>
              <Box>
                <Typography sx={heroTitle}>Transaction History</Typography>
                <Typography sx={heroSubtitle}>
                  View all financial transactions across sub-accounts
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Filter Card */}
          <Box sx={filterCard}>
            <Grid container spacing={2} alignItems="center">
              <Grid size={{ xs: 12, sm: 4, md: 2 }}>
                <Typography sx={{ color: "var(--text-color)", fontWeight: 600, fontSize: "0.9rem" }}>
                  Select Sub Account
                </Typography>
              </Grid>
              <Grid size={{ xs: 12, sm: 8, md: 4 }}>
                <FormControl fullWidth sx={modernFieldStyle}>
                  <InputLabel>Select Sub Accounts</InputLabel>
                  <Select
                    value={selectedSubAccount}
                    label="Select Sub Accounts"
                    onChange={handleChange}
                  >
                    <MenuItem value="">
                      <em>Select Sub Accounts</em>
                    </MenuItem>
                    {subAccountsData?.map((account) => (
                      <MenuItem key={account.uuid} value={account}>
                        {account.email}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          {/* Main Content Card */}
          <Box sx={mainCard}>
            {/* Tabs */}
            <Box sx={tabsWrap}>
              <Tabs
                value={value}
                aria-label="market tabs"
                onChange={(e, newValue) => setValue(newValue)}
                sx={{
                  "& .MuiTabs-indicator": {
                    backgroundColor: btncolor,
                    height: "2px",
                    borderRadius: "2px",
                  },
                }}
              >
                <Tab
                  value="spot"
                  label="Spot"
                  sx={tabItem}
                  onClick={() => {
                    handleTabChange();
                    getSpotTranscationHistory(1);
                  }}
                />
                {brokerMarkets?.isFutures === 1 && (
                  <Tab
                    value="futures"
                    label="Futures"
                    sx={tabItem}
                    onClick={() => {
                      handleTabChange();
                      renderFuturesTxnHistory(1);
                    }}
                  />
                )}
                {brokerMarkets?.isOptions === 1 && (
                  <Tab
                    value="options"
                    label="Options"
                    sx={tabItem}
                    onClick={() => {
                      handleTabChange();
                      renderOptionsTxnHistory(1);
                    }}
                  />
                )}
              </Tabs>
            </Box>

            {/* Spot Tab */}
            {value === "spot" && (
              <Box sx={{ p: { xs: 2, md: 3 } }}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 700, color: "var(--text-color)" }}
                  >
                    Transaction History
                  </Typography>
                  <IconButton size="small" sx={{ ml: 0.5 }}>
                    <InfoIcon sx={{ fontSize: "16px", color: "var(--text-color)", opacity: 0.5 }} />
                  </IconButton>
                </Box>
                <TableContainer component={Box} sx={modernTableContainer}>
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={modernTableHeadRow}>
                        <TableCell sx={modernTableHeadCell}>Date - Time</TableCell>
                        <TableCell sx={modernTableHeadCell}>TXN ID</TableCell>
                        <TableCell sx={modernTableHeadCell}>Description</TableCell>
                        <TableCell sx={modernTableHeadCell}>Type</TableCell>
                        <TableCell sx={modernTableHeadCell}>Asset</TableCell>
                        <TableCell sx={modernTableHeadCell}>Status</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {historyDetailsMod.map((data, index) => (
                        <TableRow key={index} sx={modernTableBodyRow}>
                          <TableCell sx={modernTableBodyCell}>{data.timestamp}</TableCell>
                          <TableCell sx={modernTableBodyCell}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <span>{data.transactionId}</span>
                              {data.copyTradeFlag === "Yes" && (
                                <Badge
                                  sx={{ px: 2, whiteSpace: "nowrap", mx: 1 }}
                                  color="primary"
                                  badgeContent="Copy Trade"
                                />
                              )}
                            </Box>
                          </TableCell>
                          <TableCell sx={modernTableBodyCell}>{data.description}</TableCell>
                          <TableCell sx={modernTableBodyCell}>
                            {data.action === "Buy" || data.action === "Sell" ? (
                              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <span>{data.action}</span>
                                <IconButton
                                  size="small"
                                  sx={{
                                    backgroundColor: btncolor,
                                    color: "#fff",
                                    "&:hover": { backgroundColor: btncolor },
                                    padding: "5px",
                                    borderRadius: "6px",
                                  }}
                                  onClick={() => clickToOpenModal(data.transactionId)}
                                >
                                  <ReceiptLongIcon sx={{ fontSize: "14px" }} />
                                </IconButton>
                              </Box>
                            ) : (
                              data.action
                            )}
                          </TableCell>
                          <TableCell sx={modernTableBodyCell}>
                            {data.action !== "Decline"
                              ? data.tradeAssetAmount
                              : `${data.baseCurrency} ${data.tradeAssetAmount}`}
                          </TableCell>
                          <TableCell
                            sx={modernTableBodyCell}
                            className={data.statusClass}
                          >
                            {data.status}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}

            {/* Futures Tab */}
            {value === "futures" && (
              <Box sx={{ p: { xs: 2, md: 3 } }}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 700, color: "var(--text-color)" }}
                  >
                    Futures Transactions History
                  </Typography>
                  <IconButton size="small" sx={{ ml: 0.5 }}>
                    <InfoIcon sx={{ fontSize: "16px", color: "var(--text-color)", opacity: 0.5 }} />
                  </IconButton>
                </Box>
                <TableContainer
                  component={Box}
                  sx={{ ...modernTableContainer, overflowX: "auto" }}
                >
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={modernTableHeadRow}>
                        {futuresTxnListHeader?.map((header, index) => (
                          <TableCell key={index} sx={modernTableHeadCell}>
                            {header}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {futuresTxnList?.map((list, index) => (
                        <TableRow key={index} sx={modernTableBodyRow}>
                          <TableCell sx={modernTableBodyCell}>{list.transactionId}</TableCell>
                          <TableCell sx={modernTableBodyCell}>{list.transactionDate}</TableCell>
                          <TableCell sx={modernTableBodyCell}>{list.description}</TableCell>
                          <TableCell sx={modernTableBodyCell}>{list.transactionType}</TableCell>
                          <TableCell sx={modernTableBodyCell}>{list.debit !== 0 ? list.debit : "-"}</TableCell>
                          <TableCell sx={modernTableBodyCell}>{list.credit !== 0 ? list.credit : "-"}</TableCell>
                          <TableCell sx={modernTableBodyCell}>{list.operationMode}</TableCell>
                          <TableCell sx={modernTableBodyCell}>{list.leverage !== 0 ? `${list.leverage}X` : "-"}</TableCell>
                          <TableCell sx={modernTableBodyCell}>{list.contractName}</TableCell>
                          <TableCell sx={modernTableBodyCell}>-</TableCell>
                          <TableCell sx={modernTableBodyCell}>{list.intCharge !== 0 ? list.intCharge : "-"}</TableCell>
                          <TableCell sx={modernTableBodyCell}>{list.amount !== 0 ? list.amount : "-"}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}

            {/* Options Tab */}
            {value === "options" && (
              <Box sx={{ p: { xs: 2, md: 3 } }}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 700, color: "var(--text-color)" }}
                  >
                    Options Transactions History
                  </Typography>
                  <IconButton size="small" sx={{ ml: 0.5 }}>
                    <InfoIcon sx={{ fontSize: "16px", color: "var(--text-color)", opacity: 0.5 }} />
                  </IconButton>
                </Box>
                <TableContainer
                  component={Box}
                  sx={{ ...modernTableContainer, overflowX: "auto" }}
                >
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={modernTableHeadRow}>
                        {optionTxnListHeader?.map((h, index) => (
                          <TableCell key={index} sx={modernTableHeadCell}>
                            {h}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {optionTxnList?.map((list, idx) => (
                        <TableRow key={idx} sx={modernTableBodyRow}>
                          <TableCell sx={modernTableBodyCell}>{list?.transactionId}</TableCell>
                          <TableCell sx={modernTableBodyCell}>{formatDate(list?.transactionDate)}</TableCell>
                          <TableCell sx={modernTableBodyCell}>{list?.description}</TableCell>
                          <TableCell sx={modernTableBodyCell}>{list?.transactionType}</TableCell>
                          <TableCell sx={modernTableBodyCell}>{list?.debit !== 0 ? list?.debit : "-"}</TableCell>
                          <TableCell sx={modernTableBodyCell}>{list?.credit !== 0 ? list?.credit : "-"}</TableCell>
                          <TableCell sx={modernTableBodyCell}>{list?.operationMode}</TableCell>
                          <TableCell sx={modernTableBodyCell}>{list?.leverage !== 0 ? `${list?.leverage}X` : "-"}</TableCell>
                          <TableCell sx={modernTableBodyCell}>{list?.contractName?.toUpperCase()}</TableCell>
                          <TableCell sx={modernTableBodyCell}>{list?.txnCharge !== 0 ? list?.txnCharge : "-"}</TableCell>
                          <TableCell sx={modernTableBodyCell}>{list?.intCharge !== 0 ? list?.intCharge : "-"}</TableCell>
                          <TableCell sx={modernTableBodyCell}>{list?.amount !== 0 ? list?.amount : "-"}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}

            {/* Pagination */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", px: 3, pb: 2.5 }}>
              <Pagination
                count={totalPages}
                page={pageNo}
                boundaryCount={2}
                siblingCount={2}
                onChange={handlePageChange}
                shape="rounded"
                size="small"
                showFirstButton
                showLastButton
                sx={{
                  "& .MuiPaginationItem-root": {
                    color: "var(--text-color)",
                    borderColor: "rgba(125,125,125,0.25)",
                    "&.Mui-selected": {
                      backgroundColor: alpha(btncolor || "#1976d2", 0.85),
                      color: "#fff",
                      borderColor: "transparent",
                    },
                    "&:hover": {
                      backgroundColor: alpha(btncolor || "#1976d2", 0.15),
                    },
                  },
                }}
              />
            </Box>
          </Box>
        </Box>
      </Grid>

      {/* Invoice Modal */}
      <ModalContent
        open={invoiceModalOpen}
        onClose={handleClose}
        title="Trading Invoice"
        width="xs"
      >
        <Box sx={{ mt: 4, textAlign: "justify", width: "100%" }}>
          <div className="row">
            <div className="col-md-12">
              <List>
                {[
                  { label: "Action", className: "actiondata", name: "action" },
                  { label: "Asset Pair", className: "assetpairdata", name: "assetPair" },
                  { label: "Trade Qty", className: "tradeqtydata", name: "tradeQty" },
                  { label: "Trade Price", className: "tradepricedata", id: "swft-noI", name: "tradePrice" },
                  { label: "Value", className: "valuedata", name: "value" },
                  { label: "Txn Charge", className: "txnchrgdata", name: "txnCharge" },
                  { label: "Gst", className: "gstdata", name: "gst" },
                  { label: "Total Value", className: "totalvaluedata", name: "totalValue" },
                  { label: "Transaction Timestamp", className: "timestampdata", name: "transactionTimestamp" },
                ].map(
                  (item) =>
                    (item?.name === "gst"
                      ? invoiceData[item.name] === "0"
                        ? false
                        : true
                      : true) && (
                      <Box
                        key={item?.label}
                        display="flex"
                        flexDirection="row"
                        alignItems="center"
                        justifyContent="space-between"
                        p={1}
                        sx={{ wordBreak: "break-word", gap: 1, m: 1, borderRadius: "5px" }}
                      >
                        <Typography sx={{ minWidth: 140, fontSize: "12px" }} noWrap>
                          {item?.label.replace(/([A-Z])/g, " $1").toUpperCase()}:
                        </Typography>
                        <Typography
                          sx={{ color: "primary.main", textAlign: "right", flex: 1, wordBreak: "break-word" }}
                          component="div"
                        >
                          <Box component="span">{invoiceData[item.name]}</Box>
                        </Typography>
                      </Box>
                    )
                )}
              </List>
            </div>
          </div>
        </Box>
      </ModalContent>
    </Grid>
  );
};

export default TransuctionHistory;
